import $ from 'jquery';
import EventEmitter from 'events';
export const mathJaxRenderEventHub = new EventEmitter();

/* eslint-disable */
window.MathJax = {
  extensions: ["mml2jax.js"],
  jax: ["input/TeX", "input/MathML", "output/HTML-CSS"],
  displayAlign: "left",
  showMathMenu: false,
  tex2jax: {
    inlineMath: [['$', '$'], ['\\(', '\\)'], ['\\begin{document}$', '$\\end{document}'], ['$$', '$$'], ['\\[', '\\]']],
    displayMath: [],
    preview: "TeX",
    processEscapes: !0
  },
  mml2jax: {
    preview: ["MathML"]
  },
  "fast-preview": {
    disabled: !0
  },
  "HTML-CSS": {
    EqnChunk: 500,
    EqnChunkFactor: 1,
    EqnChunkDelay: 1e3,
    availableFonts: ["STIX", "TeX"],
    preferredFont: ["STIX"],
    webFont: ["TeX"],
    imageFont: ["TeX"],
    styles: {
      ".MathJax_Display": {
        margin: 0
      },
      "#MathJax_Message": {
        margin: 0
      },
      '.MathJax': { outline: 0 },
    }
  },
  TeX: {
    noErrors: {
      style: {
        'font-size': 'normal',
        'border': ''
      }
    },
    noUndefined: { disabled: true },
    TagSide: "right",
    Macros: {
      bgroup: "{\\unicode{x007B}}",
      egroup: "{\\unicode{x007D}}",
      enskip: "{\\enspace}",
      lefteqn: ["\\rlap{#1}", 1],
      parbox: ["\\mbox{#2}", 2],
      upvarepsilon: "{\\unicode{x03B5}}",
      ss: "{\\unicode{x1E9E}}",
      textquotedblright: "{\\unicode{x201D}}",
      textregistered: "{\\unicode{0x00AE}}",
      upvartheta: "{\\unicode{x03D1}}",
      Upvartheta: "{\\unicode{x03F4}}",
      Upgamma: "{\\unicode{x0393}}",
      upgamma: "{\\unicode{x03B3}}",
      Updelta: "{\\unicode{x0394}}",
      updelta: "{\\unicode{x03B4}}",
      Uptheta: "{\\unicode{x0398}}",
      uptheta: "{\\unicode{x03B8}}",
      Upkappa: "{\\unicode{x039A}}",
      upkappa: "{\\unicode{x03BA}}",
      Uplambda: "{\\unicode{x039B}}",
      uplambda: "{\\unicode{x03BB}}",
      Upsigma: "{\\unicode{x03A3}}",
      upsigma: "{\\unicode{x03C3}}",
      Upmu: "{\\unicode{x039C}}",
      upmu: "{\\unicode{x03BC}}",
      Upiota: "{\\unicode{x0399}}",
      upiota: "{\\unicode{x03B9}}",
      Upnu: "{\\unicode{x039D}}",
      upnu: "{\\unicode{x03BD}}",
      Upxi: "{\\unicode{x039E}}",
      upxi: "{\\unicode{x03BE}}",
      Upomicron: "{\\unicode{x039F}}",
      upomicron: "{\\unicode{x03BF}}",
      Uppi: "{\\unicode{x03A0}}",
      uppi: "{\\unicode{x03C0}}",
      Uprho: "{\\unicode{x03A1}}",
      uprho: "{\\unicode{x03C1}}",
      Uptau: "{\\unicode{x03A4}}",
      uptau: "{\\unicode{x03C4}}",
      Upupsilon: "{\\unicode{x03A5}}",
      upupsilon: "{\\unicode{x03C5}}",
      Upphi: "{\\unicode{x03A6}}",
      upphi: "{\\unicode{x03C6}}",
      Upchi: "{\\unicode{x03A7}}",
      upchi: "{\\unicode{x03C7}}",
      Uppsi: "{\\unicode{x03A8}}",
      uppsi: "{\\unicode{x03C8}}",
      Upomega: "{\\unicode{x03A9}}",
      upomega: "{\\unicode{x03C9}}",
      upalpha: "{\\unicode{x03B1}}",
      upbeta: "{\\unicode{x03B2}}",
      upepsilon: "{\\unicode{x03B5}}",
      upzeta: "{\\unicode{x03B6}}",
      upeta: "{\\unicode{x03B7}}",
      permille: "{\\unicode{x2030}}",
      hfill: "{\\enspace\\enspace}",
      copyright: "{\\unicode{x00A9}}",
      dag: "{\\unicode{x2020}}",
      ddag: "{\\unicode{x2021}}",
      ointop: "{\\unicode{0x222E}}",
      P: "{\\unicode{0x00B6}}",
      lhook: "{\\hookrightarrow}",
      rhook: "{\\hookleftarrow}",
      fancyscript: ["{\\scr #1}", 1],
      varvec: ["\\pmb{#1}", 1]
    }
  },
  AuthorInit: function () {
    MathJax.Hub.Register.StartupHook("TeX Jax Ready", function () {
      MathJax.InputJax.TeX.prefilterHooks.Add(function (a) {
        a.math = a.math.replace(/\\hbox\s*\{\s*\\AA\s*\}/g, "\\unicode{x212B}"),
          a.math = a.math.replace(/\\AA/g, "{\\it\\unicode{x212B}}"),
          a.math = a.math.replace(/\\lowercase\s*\{([A-Z])\}/g, function (a, e) {
            return [e.toLowerCase()]
          }),
          a.math = a.math.replace(/\\uppercase\s*\{([a-z])\}/g, function (a, e) {
            return [e.toUpperCase()]
          }),
          a.math = a.math.replace(/\\lowercase\s*\{(.*?)\}/g, "$1"),
          a.math = a.math.replace(/\\uppercase\s*\{(.*?)\}/g, "$1"),
          a.math = a.math.replace(/\\textendash/g, "{-}"),
          a.math = a.math.replace(/\\selectfont/g, ""),
          a.math = a.math.replace(/\\textup/g, "\\text"),
          a.math = a.math.replace(/\\hdots/g, "\\ldots"),
          a.math = a.math.replace(/\\nicefrac/g, "\\bfrac"),
          a.math = a.math.replace(/\\noalign/g, ""),
          a.math = a.math.replace(/\\medskip/g, ""),
          a.math = a.math.replace(/\\mathbbm \{C\}/g, "{\\unicode{x2102}}"),
          a.math = a.math.replace(/\\mathbbm\s*\{([A-Z])\}/g, "\\mathbb{$1}"),
          a.math = a.math.replace(/\\mathbbm\s*\{a\}/g, "\\unicode{x1D552}"),
          a.math = a.math.replace(/\\mathbbm\s*\{b\}/g, "\\unicode{x1D553}"),
          a.math = a.math.replace(/\\mathbbm\s*\{c\}/g, "\\unicode{x1D554}"),
          a.math = a.math.replace(/\\mathbbm\s*\{d\}/g, "\\unicode{x1D555}"),
          a.math = a.math.replace(/\\mathbbm\s*\{e\}/g, "\\unicode{x1D556}"),
          a.math = a.math.replace(/\\mathbbm\s*\{f\}/g, "\\unicode{x1D557}"),
          a.math = a.math.replace(/\\mathbbm\s*\{g\}/g, "\\unicode{x1D558}"),
          a.math = a.math.replace(/\\mathbbm\s*\{h\}/g, "\\unicode{x1D559}"),
          a.math = a.math.replace(/\\mathbbm\s*\{i\}/g, "\\unicode{x1D55A}"),
          a.math = a.math.replace(/\\mathbbm\s*\{j\}/g, "\\unicode{x1D55B}"),
          a.math = a.math.replace(/\\mathbbm\s*\{k\}/g, "\\unicode{x1D55C}"),
          a.math = a.math.replace(/\\mathbbm\s*\{l\}/g, "\\unicode{x1D55D}"),
          a.math = a.math.replace(/\\mathbbm\s*\{m\}/g, "\\unicode{x1D55E}"),
          a.math = a.math.replace(/\\mathbbm\s*\{n\}/g, "\\unicode{x1D55F}"),
          a.math = a.math.replace(/\\mathbbm\s*\{o\}/g, "\\unicode{x1D560}"),
          a.math = a.math.replace(/\\mathbbm\s*\{p\}/g, "\\unicode{x1D561}"),
          a.math = a.math.replace(/\\mathbbm\s*\{q\}/g, "\\unicode{x1D562}"),
          a.math = a.math.replace(/\\mathbbm\s*\{r\}/g, "\\unicode{x1D563}"),
          a.math = a.math.replace(/\\mathbbm\s*\{s\}/g, "\\unicode{x1D564}"),
          a.math = a.math.replace(/\\mathbbm\s*\{t\}/g, "\\unicode{x1D565}"),
          a.math = a.math.replace(/\\mathbbm\s*\{u\}/g, "\\unicode{x1D566}"),
          a.math = a.math.replace(/\\mathbbm\s*\{v\}/g, "\\unicode{x1D567}"),
          a.math = a.math.replace(/\\mathbbm\s*\{w\}/g, "\\unicode{x1D568}"),
          a.math = a.math.replace(/\\mathbbm\s*\{x\}/g, "\\unicode{x1D569}"),
          a.math = a.math.replace(/\\mathbbm\s*\{y\}/g, "\\unicode{x1D56A}"),
          a.math = a.math.replace(/\\mathbbm\s*\{z\}/g, "\\unicode{x1D56B}"),
          a.math = a.math.replace(/\\mathbbm\s*\{0\}/g, "\\unicode{x1D7D8}"),
          a.math = a.math.replace(/\\mathbbm\s*\{1\}/g, "\\unicode{x1D7D9}"),
          a.math = a.math.replace(/\\mathbbm\s*\{2\}/g, "\\unicode{x1D7DA}"),
          a.math = a.math.replace(/\\mathbb\s*\{a\}/g, "\\unicode{x1D552}"),
          a.math = a.math.replace(/\\mathbb\s*\{b\}/g, "\\unicode{x1D553}"),
          a.math = a.math.replace(/\\mathbb\s*\{c\}/g, "\\unicode{x1D554}"),
          a.math = a.math.replace(/\\mathbb\s*\{d\}/g, "\\unicode{x1D555}"),
          a.math = a.math.replace(/\\mathbb\s*\{e\}/g, "\\unicode{x1D556}"),
          a.math = a.math.replace(/\\mathbb\s*\{f\}/g, "\\unicode{x1D557}"),
          a.math = a.math.replace(/\\mathbb\s*\{g\}/g, "\\unicode{x1D558}"),
          a.math = a.math.replace(/\\mathbb\s*\{h\}/g, "\\unicode{x1D559}"),
          a.math = a.math.replace(/\\mathbb\s*\{i\}/g, "\\unicode{x1D55A}"),
          a.math = a.math.replace(/\\mathbb\s*\{j\}/g, "\\unicode{x1D55B}"),
          a.math = a.math.replace(/\\mathbb\s*\{k\}/g, "\\unicode{x1D55C}"),
          a.math = a.math.replace(/\\mathbb\s*\{l\}/g, "\\unicode{x1D55D}"),
          a.math = a.math.replace(/\\mathbb\s*\{m\}/g, "\\unicode{x1D55E}"),
          a.math = a.math.replace(/\\mathbb\s*\{n\}/g, "\\unicode{x1D55F}"),
          a.math = a.math.replace(/\\mathbb\s*\{o\}/g, "\\unicode{x1D560}"),
          a.math = a.math.replace(/\\mathbb\s*\{p\}/g, "\\unicode{x1D561}"),
          a.math = a.math.replace(/\\mathbb\s*\{q\}/g, "\\unicode{x1D562}"),
          a.math = a.math.replace(/\\mathbb\s*\{r\}/g, "\\unicode{x1D563}"),
          a.math = a.math.replace(/\\mathbb\s*\{s\}/g, "\\unicode{x1D564}"),
          a.math = a.math.replace(/\\mathbb\s*\{t\}/g, "\\unicode{x1D565}"),
          a.math = a.math.replace(/\\mathbb\s*\{u\}/g, "\\unicode{x1D566}"),
          a.math = a.math.replace(/\\mathbb\s*\{v\}/g, "\\unicode{x1D567}"),
          a.math = a.math.replace(/\\mathbb\s*\{w\}/g, "\\unicode{x1D568}"),
          a.math = a.math.replace(/\\mathbb\s*\{x\}/g, "\\unicode{x1D569}"),
          a.math = a.math.replace(/\\mathbb\s*\{y\}/g, "\\unicode{x1D56A}"),
          a.math = a.math.replace(/\\mathbb\s*\{z\}/g, "\\unicode{x1D56B}"),
          a.math = a.math.replace(/\\mathbb\s*\{0\}/g, "\\unicode{x1D7D8}"),
          a.math = a.math.replace(/\\mathbb\s*\{1\}/g, "\\unicode{x1D7D9}"),
          a.math = a.math.replace(/\\mathbb\s*\{2\}/g, "\\unicode{x1D7DA}"),
          a.math = a.math.replace(/\\coloneq/g, ":="),
          a.math = a.math.replace(/\\kern *-\\nulldelimiterspace/g, ""),
          a.math = a.math.replace(/\\user2/g, "\\pmb"),
          a.math = a.math.replace(/\\mapstochar/g, "\\mapsto"),
          a.math = a.math.replace(/\s*<!\[CDATA\[\s*(.*)\s*\]\]>\s*/gm, "$1"),
          a.math = a.math.replace(/{?\\ss}?/g, "ß"),
          a.math = a.math.replace(/\\"a|{\\"a}|\\"{a}/g, "ä"),
          a.math = a.math.replace(/\\"o|{\\"o}|\\"{o}/g, "ö"),
          a.math = a.math.replace(/\\"u|{\\"u}|\\"{u}/g, "ü"),
          a.math = a.math.replace(/\\parbox(\[\w\])?{(.*?)}{(.*?)\\\\ (.*?)}/g, "\\parbox{$2}{$3 $4}"),
          a.math = a.math.replace(/\\vspace\*?{[^}]+}/g, ""),
          a.math = a.math.replace(/\\vspace\s*\*\{([^\{\}]+)\}/g, ""),
          a.math = a.math.replace(/\\vspace\*?{[^}]+}/g, ""),
          a.math = a.math.replace(/\\text{\\small{([^}]+)}}/g, "\\scriptstyle{\\text{$1}}"),
          a.math = a.math.replace(/\\text{\\footnotesize{([^}]+)}}/g, "\\scriptstyle{\\text{$1}}"),
          a.math = a.math.replace(/\\text{\\scriptsize{([^}]+)}}/g, "\\scriptscriptstyle{\\text{$1}}"),
          a.math = a.math.replace(/\\text{\\tiny{([^}]+)}}/g, "\\scriptscriptstyle{\\text{$1}}"),
          a.math = a.math.replace(/\\text\{\\bf\{([^\{\}]+)\}\}/g, "\\textbf{$1}"),
          a.math = a.math.replace(/\\text\{\\mathbf\{([^\{\}]+)\}\}/g, "\\textbf{$1}"),
          a.math = a.math.replace(/\\textrm/g, "\\mathrm"),
          a.math = a.math.replace(/\\bf{/g, "\\mathbf{"),
          a.math = a.math.replace(/\\text\\EUR/g, "€"),
          a.math = a.math.replace(/\\mathop ([^{]+?)\\limits/g, "\\mathop{$1}\\limits"),
          a.math = a.math.replace(/{?\\ss}?/g, "ﬂ"),
          a.math = a.math.replace(/\\"a|{\\"a}|\\"{a}/g, "‰"),
          a.math = a.math.replace(/\\"o|{\\"o}|\\"{o}/g, "ˆ"),
          a.math = a.math.replace(/\\"u|{\\"u}|\\"{u}/g, "¸"),
          a.math = a.math.replace(/\\user1/g, "\\mathcal"),
          a.math = a.math.replace(/\\(big|Big|bigg|Bigg) *{([^}]+)}/g, "\\$1$2"),
          a.math = a.math.replace(/\\textnormal{\\textsc{([^}]+)}}/g, "\\textsc {$1}"),
          a.math = a.math.replace(/\\textsc *{([^}]+)}/g, "{\\rm ~#~$1~#~}"),
          a.math = a.math.replace(/\\upvarphi/g, "\\varphi"),
          a.math = a.math.replace(/\\llbracket/g, "⟦"),
          a.math = a.math.replace(/\\rrbracket/g, "⟧"),
          a.math = a.math.replace(/\\pounds/g, "£"),
          a.math = a.math.replace(/\\raisebox *{-[^}]+}{\$(.+?)\$}/g, "_{$1}"),
          a.math = a.math.replace(/\\raisebox *{[^}]+}{\$(.+?)\$}/g, "^{$1}"),
          a.math = a.math.replace(/\\CIRCLE/g, "{\\large\\unicode[.55,0.05]{x25CF}}"),
          a.math = a.math.replace(/\\LEFTcircle/g, "{\\large\\unicode[.55,0.05]{x25D1}}"),
          a.math = a.math.replace(/\\RIGHTcircle/g, "{\\large\\unicode[.55,0.05]{x25D0}}"),
          a.math = a.math.replace(/\\fontencoding{U}\Sfontfamily{wasy}\Sselectfont\Schar104/g, "‰");
        for (var e, t = new RegExp("~#~(.*?)~#~", "g"); e = t.exec(a.math);) {
          for (var m = "", h = 0; h != e[1].length; h++) {
            var c = e[1].substr(h, 1);
            c.match(/[a-z]/) ? m += "{\\small " + c.toUpperCase() + "}" : m += c
          }
          a.math = a.math.replace(/~#~.*?~#~/, m)
        }
      });

      var m = MathJax.ElementJax.mml
        , a = MathJax.InputJax.TeX;
      a.Definitions.macros.bfrac = "myBevelFraction",
        a.Parse.Augment({
          myBevelFraction: function (a) {
            var e = this.ParseArg(a)
              , t = this.ParseArg(a);
            this.Push(m.mfrac(e, t).With({
              bevelled: !0
            }))
          }
        })
    });
  }
}
// <script type="text/x-mathjax-config">
//   window['M_CB_XXXX] = () => resolve(window.MathJax)
// </script>
// <script src='http://s3.cn-northwest-1.amazonaws.com.cn/qa-static-analytics.cdn.zhihuiya.com-cn-northwest-1/mathjax/MathJax.js?config=MML_HTMLorMML-full' async></script>

let mathLoadPromise = null;
let resolvedMJ = false;

const loadMathJs = () => {
    if (resolvedMJ) {
        return Promise.resolve(resolvedMJ);
    }
    if (mathLoadPromise) {
        return Promise.resolve(mathLoadPromise);
    }

    const head = document.getElementsByTagName('head')[0];
    const mathCallbackScript = document.createElement('script');
    const script = document.createElement('script');

    mathCallbackScript.type = 'text/x-mathjax-config';
    const callbackFnName = `M_CB_${Math.random()}`;

    mathLoadPromise = new Promise((resolve, reject) => {
        window[callbackFnName] = () => {
            resolvedMJ = window.MathJax;
            resolve(resolvedMJ);
        };
        script.onerror = reject;
    });

    mathCallbackScript.innerHTML = `
    MathJax.Hub.Config({
        skipStartupTypeset: true, // No auto render
    });
    MathJax.Hub.Register.StartupHook("End",function () {
        window['${callbackFnName}']();
    });
    `;

    script.type = 'text/javascript';
    script.src = `${process.env['VUE_APP_STATIC_COMMON_URL']}/mathjax/MathJax.js?config=TeX-AMS-MML_HTMLorMML`;
    [mathCallbackScript, script].forEach(item => {
        item.charset = 'utf-8';
        head.appendChild(item);
    });

    mathLoadPromise.then((MathJaxInstance) => {
        mathLoadPromise = MathJaxInstance;
    });

    return mathLoadPromise;
};

export function callMathRender(el) {
    setTimeout(function() {
        loadMathJs().then(function(MathJax) {
            setTimeout(function() {
                $(el)
                    .find('[data-mathml~=error]')
                    .each(function(idx, ele) {
                        const $ele = $(ele);
                        const id = $ele.attr('id').replace('-Frame', '');
                        const $sourceScript = $(`#${id}`);
                        const oriHTML = $sourceScript.html();
                        $ele.replaceWith(oriHTML);
                    });
                $(el)
                    .find('.MathJax_Error')
                    .each(function(idx, ele) {
                        const rawHTML = $(ele)
                            .siblings('[type^=math]')
                            .html();
                        if (rawHTML) {
                            $(ele).replaceWith(rawHTML);
                        }
                    });
                mathJaxRenderEventHub.emit('done');
            }, 2000);
            MathJax.Hub.Queue(['Typeset', MathJax.Hub, el]);
        });
    }, 200);
}

const hasMutationOb = 'MutationObserver' in window;
export function observe(el, cb) {
    const config = { attributes: false, childList: true };
    if (hasMutationOb && typeof cb === 'function') {
        el._mathMuObserver = new MutationObserver(cb);
        el._mathMuObserver.observe(el, config);
        return true;
    }
    if (el._mathMuObserver) {
        el._mathMuObserver.disconnect();
    }
    return false;
}